<template>
	<div>
		<el-dialog :title="xjtitle" :visible.sync="xjdialog" width="950px" :close-on-click-modal="false" v-dialogDrag>
			<!-- <minhead :headtitle="xjtitle" :isdiag="true"></minhead> -->
			<div class="xjall">
				<div class="diagtitle">规则作用范围</div>
				<div class="Centerupdown" style="margin-top: 20px;margin-left: 60px;">
					<span style="width: 100px;">有效范围</span>
					<el-select v-model="kehfw" placeholder="请选择" style="width: 140px;" @change="kehfwChange">
						<el-option v-for="item in yxfwoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div style="margin-top: 20px;margin-left: 60px;" class="Centerupdown">
					<div class="Centerupdown">
						<span style="width: 100px;">客户代码</span>
						<el-select multiple :disabled="kehfw == '0'" v-model="goufbh" placeholder="请选择" style="width: 140px;">
							<el-option v-for="item in kehuoptions" :key="item.goufbh" :label="item.goufbh" :value="item.goufbh"></el-option>
						</el-select>
					</div>
					<div class="Centerupdown" style="margin-left: 60px;">
						<span style="width: 100px;">客户名称</span>
						<el-select multiple :disabled="kehfw == '0'" v-model="goufbh" placeholder="请选择" style="width: 140px;">
							<el-option v-for="item in kehuoptions" :key="item.goufbh" :label="item.goufmc" :value="item.goufbh"></el-option>
						</el-select>
					</div>
				</div>
				<div class="Centerupdown" style="margin-top: 20px;margin-left: 60px;" v-if="guizlxbh != '1'">
					<span style="width: 100px;">有效发票类型</span>
					<el-select v-model="fpfw" placeholder="请选择" style="width: 140px;" @change="fpfwChange">
						<el-option v-for="item in yxfwoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="Centerupdown" style="margin-top: 20px;margin-left: 60px;">
					<span style="width: 100px;">发票类型</span>
					<el-select :disabled="fpfw == '0'" v-model="fplxs" :multiple="guizlxbh != '1'" placeholder="请选择" style="width: 140px;" @change="fplxChange">
						<el-option v-for="item in fplxoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div>
				<div class="diagtitle">筛选条件</div>
				<div style="margin-top: 20px;margin-left: 0px;margin-bottom: 28px;">
					<div v-for="(item, index) in shaixtj" class="Centerupdown" style="margin-top: 10px;">
						<el-select v-model="item.zidm" style="width: 180px;margin-left: 60px;">
							<el-option v-for="item in shaixuanoptions" :key="item.value" :label="item.value" :value="item.key"></el-option>
						</el-select>
						<el-select v-model="item.caozf" style="width:100px;margin-left: 20px;">
							<el-option v-for="item in caozfoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
						<!--如果选择字段为合计金额，价税合计、税率、金额，则将输入框改为数字框并保留两位小数-->
						<el-input-number
							v-if="item.zidm == 'hejje' || item.zidm == 'jiashj' || item.zidm == 'shuil' || item.zidm == 'jine'"
							style="width: 180px;margin-left: 20px;"
							:controls="false"
							:precision="2"
							v-model="item.zhi"
						></el-input-number>
						<el-input v-else style="width: 180px;margin-left: 20px;" v-model="item.zhi"></el-input>
						<div class="addstyle" style="width: 60px;margin-left: 20px;" @click="addshaixtj" v-if="index == shaixtj.length - 1">增加</div>
						<div class="dangestyle" style="width: 60px;margin-left: 20px;" @click="delteshaixtj(index)">删除</div>
					</div>
				</div>
				<div v-if="guizlxbh == '1'">
					<div class="diagtitle">拆分参数</div>
					<div class="Centerupdown" style="margin-top: 20px;margin-left: 60px;">
						<div style="width: 100px;">最大拆分金额</div>
						<el-input-number
							v-if="splitMaxAmount != ''"
							style="width: 300px;"
							:min="0"
							:controls="false"
							:precision="2"
							v-model="subform.zuidcfje"
							:max="splitMaxAmount"
						></el-input-number>
						<el-input-number v-else style="width: 300px;" :min="0" :controls="false" :precision="2" v-model="subform.zuidcfje"></el-input-number>
					</div>
				</div>
				<div v-if="guizlxbh == '2'">
					<div class="diagtitle">拆分参数</div>
					<div style="margin-top: 20px;margin-left: 60px;" class="Centerupdown">
						<div class="Centerupdown">
							<span>数量</span>
							<el-select v-model="subform.chaifsl" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in chaifennumoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
						<div class="Centerupdown" style="margin-left: 60px;">
							<span>单价</span>
							<el-select v-model="subform.chaifdj" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in chaifennumoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
					<div class="Centerupdown" style="margin-top: 20px;margin-left: 60px;">
						<span>最大行数</span>
						<el-input-number style="width: 140px;" :min="0" :controls="false" :precision="0" v-model="subform.chaifzdhs"></el-input-number>
					</div>
				</div>
				<div v-if="guizlxbh == '3'">
					<div class="diagtitle">分组条件</div>
					<div style="margin-top: 20px;margin-left: 0px;">
						<div v-for="(item, index) in subform.fenzulist" class="Centerupdown" style="margin-top: 10px;">
							<el-select v-model="item.hebzdm" style="width: 180px;margin-left: 60px;">
								<el-option v-for="item in shaixuanoptions" :key="item.value" :label="item.value" :value="item.key"></el-option>
							</el-select>

							<div class="addstyle"  style="width: 60px;margin-left: 20px;"@click="addfenzulist" v-if="index == subform.fenzulist.length - 1">增加</div>
							<div class="dangestyle" style="width: 60px;margin-left: 20px;" @click="deltefenzulist(index)">删除</div>
						</div>
					</div>
					<div class="diagtitle">分组参数</div>
					<div style="margin-top: 20px;margin-left: 60px;" class="Centerupdown">
						<div class="Centerupdown">
							<span>备注</span>
							<el-select v-model="subform.fenzbz" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in bzoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							<el-input style="width: 140px;margin-left: 10px;" v-model="subform.fenzbzz" v-if="subform.fenzbz == 2"></el-input>
						</div>
						<div class="Centerupdown" style="margin-left: 60px;">
							<span>最大金额</span>
							<el-input-number style="width: 140px;" :min="0" :controls="false" :precision="2" v-model="subform.fenzzdje"></el-input-number>
						</div>
					</div>
				</div>
				<div v-if="guizlxbh == '4'">
					<div class="diagtitle" style="margin-top: 28px;">合并条件</div>
					<div style="margin-top: 20px;margin-left: 0px;">
						<div v-for="(item, index) in subform.hblist" class="Centerupdown" style="margin-top: 10px;">
							<el-select v-model="item.zidm" style="width: 180px;margin-left: 60px;">
								<el-option v-for="item in fenzuoptions" :key="item.value" :label="item.value" :value="item.key"></el-option>
							</el-select>

							<div class="blueicon" @click="addhblist" v-if="index == subform.hblist.length - 1">增加</div>
							<div class="redicon" @click="deltehblist(index)">删除</div>
						</div>
					</div>
					<div class="diagtitle">合并参数</div>
					<div style="margin-top: 20px;margin-left: 60px;" class="Centerupdown">
						<div class="Centerupdown">
							<span>数量</span>
							<el-select v-model="subform.hebsl" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in hbnumberoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							<el-input-number
								style="width: 140px;margin-left: 10px;"
								:min="0"
								:controls="false"
								v-model="subform.hebslz"
								v-if="subform.hebsl == 3"
							></el-input-number>
						</div>
						<div class="Centerupdown" style="margin-left: 60px;">
							<span>单价</span>
							<el-select v-model="subform.hebdj" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in hbpriceoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							<el-input-number
								style="width: 140px;margin-left: 10px;"
								:min="0"
								:controls="false"
								v-model="subform.hebdjz"
								v-if="subform.hebdj == 2"
							></el-input-number>
						</div>
					</div>
					<div style="margin-top: 20px;margin-left: 60px;" class="Centerupdown">
						<div class="Centerupdown">
							<span>商品名</span>
							<el-select v-model="subform.hebspm" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in hbshopoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							<el-input style="width: 140px;margin-left: 10px;" v-model="subform.hebspmz" v-if="subform.hebspm == 2"></el-input>
						</div>
						<div class="Centerupdown" style="margin-left: 60px;">
							<span>规格</span>
							<el-select v-model="subform.hebgg" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in hbguigeoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							<el-input style="width: 140px;margin-left: 10px;" v-model="subform.hebggz" v-if="subform.hebgg == 2"></el-input>
						</div>
					</div>
					<div style="margin-top: 20px;margin-left: 60px;" class="Centerupdown">
						<div class="Centerupdown">
							<span>单位</span>
							<el-select v-model="subform.hebdw" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in hbdanweioptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							<el-input style="width: 140px;margin-left: 10px;" v-model="subform.hebdwz" v-if="subform.hebdw == 2"></el-input>
						</div>
						<div class="Centerupdown" style="margin-left: 60px;">
							<span>明细备注</span>
							<el-select v-model="subform.hebbz" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in hbbzoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							<el-input style="width: 140px;margin-left: 10px;" v-model="subform.hebbzz" v-if="subform.hebbz == 2"></el-input>
						</div>
					</div>
				</div>
				<div v-if="guizlxbh == '5'">
					<div class="diagtitle">替换参数</div>
					<div style="margin-top: 20px;margin-left: 60px;" class="Centerupdown">
						<div class="Centerupdown">
							<span>替换名称</span>
							<el-select v-model="subform.tihmc" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in tihoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
						<div class="Centerupdown" style="margin-left: 60px;">
							<span>替换值</span>
							<el-input style="width: 140px;" v-model="subform.tihz"></el-input>
						</div>
					</div>
				</div>
				<div v-if="guizlxbh == '9'">
					<div class="diagtitle">单据状态</div>
					<div style="margin-top: 20px;margin-left: 60px;" class="Centerupdown">
						<div class="Centerupdown">
							<span>单据状态</span>
							<el-select v-model="subform.danjzt" placeholder="请选择" style="width: 140px;">
								<el-option v-for="item in danjuoptions" :key="item.value" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div v-if="guizlxbh == '10'">
					<div class="diagtitle" style="margin-top: 28px;">备注处理</div>
					<div style="margin-top: 20px;margin-left: 0px;" class="bzchli">
						<div v-for="(item, index) in subform.bzlist" class="Centerupdown" style="margin-top: 10px;">
							<el-select :disabled="item.beizxglx == '3'" v-model="item.beizxgzd" style="width: 160px;margin-left: 60px;">
								<el-option v-for="item in shaixuanoptions" :key="item.value" :label="item.value" :value="item.key"></el-option>
							</el-select>
							<el-radio v-model="item.beizxglx" label="1"></el-radio>
							<el-select :disabled="item.beizxglx == '2' || item.beizxglx == '3'" placeholder="" v-model="item.beizxgwz" style="width: 80px;margin-left: 0px;">
								<el-option v-for="item in bzwzoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
							<el-input style="width: 60px;" :disabled="item.beizxglx == '2' || item.beizxglx == '3'" v-model="item.beizxgws"></el-input>
							<el-radio v-model="item.beizxglx" label="2" style="margin-left: 20px;"></el-radio>
							<span style="width: 90px;">正则表达式</span>
							<el-input style="width: 120px;" :disabled="item.beizxglx == '1' || item.beizxglx == '3'" v-model="item.beizxgzzbds"></el-input>
							<el-radio v-model="item.beizxglx" label="3"></el-radio>
							<span>固定文本</span>
							<el-input style="width: 120px;" :disabled="item.beizxglx == '1' || item.beizxglx == '2'" v-model="item.beizxgwb"></el-input>
							<div class="addstyle" style="width: 60px;margin-left: 20px;" @click="addbzlist" v-if="index == subform.bzlist.length - 1">增加</div>
							<div class="dangestyle" style="width: 60px;margin-left: 20px;" @click="deltebzlist(index)">删除</div>
						</div>
					</div>
				</div>
				<div style="margin-top: 18px;padding-bottom: 21px;" class="between-line">
					<div></div>
					<div style="justify-content: center; display: flex;margin-right: 17px;">
						<div class="addstyle"style="width:60px;margin-right: 20px;"   @click="forsaveRule()" >确定</div>
						<div class="backstyle" style="width:60px" @click="xjdialog = false">取消</div>
					</div>
					<!-- <div class="rightbuttom">
						<div  class="addstyle"  @click="forsaveRule">确认</div>
						<div @click="xjdialog = false">取消</div>
					</div> -->
				</div>
			</div>
		</el-dialog>
		<minhead :headtitle="headtitle"></minhead>

		<base-rule
			v-if="baseRuleDoalog"
			:viewFlag="viewFlag"
			:baseRuleDoalog="baseRuleDoalog"
			:baseRuleData="baseRuleData"
			@closeDialog="closeDialog"
			@saveBaseRuleData="saveBaseRuleData"
		></base-rule>

		<div class="areacontent">
			<div class="between-line">
				<div class="Centerupdown">
					<el-dropdown @command="foradddiag">
						<!-- <el-button type="primary">
							新建规则
							<i class="el-icon-circle-plus-outline el-icon--right"></i>
						</el-button> -->
						<div class="addstyle" style="width: 120px;">
							<samp>
							新建规则
							<i class="el-icon-circle-plus-outline el-icon--right"></i>
							</samp>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="item in options" :command="item.value">{{ item.label }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!-- <el-button style="margin-left: 20px;" @click="viewRow(1)" type="primary">基础规则</el-button> -->
					<div class="addstyle" style="width: 120px;margin-left: 20px;"  @click="viewRow(1)">
						<samp>
						基础规则
						</samp>
					</div>
				</div>

				<div class="Centerupdown">
					<el-input
						@input="changebilling"
						clearable
						style="width: 300px;margin-left: 20px;margin-right: 16px;"
						placeholder="客户代码,客户名称"
						prefix-icon="el-icon-search"
						v-model="serchval"
					></el-input>
				</div>
			</div>
			<div class="areatable">
				<div class="tableh">
					<el-table :data="tableData" border style="width: 100%" height="calc(100vh - 262px )" ref="multipleTable">
						<el-table-column prop="ruleType" label="类型" align="center">
							<template slot-scope="scope">
								<span>{{ ruleTypetostring(scope.row.ruleType) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="date" label="有效范围" align="center">
							<template slot-scope="scope">
								<span>{{ kehfwtostring(scope.row.kehfw) }}</span>
							</template>
						</el-table-column>

						<el-table-column prop="kehbh" label="客户代码" align="center"></el-table-column>
						<el-table-column prop="kehmc" label="客户名称" align="left" min-width="160px" show-overflow-tooltip ></el-table-column>
						<el-table-column prop="city" label="规则类型" align="center">
							<template slot-scope="scope">
								<span>{{ formatkpgz(scope.row.guizlxbh) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="fplxs" label="发票类型" align="center">
							<template slot-scope="scope">
								<span>{{ fplxtostring(scope.row.fplxs) }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="shunx" label="优先顺序" align="center"></el-table-column>
						<el-table-column label="移动" align="center" width="180px">
							<template slot-scope="scope">
								<div class="distribution-line" style="width: 100%;">
									<div class="Centerupdown" v-if="scope.row.shunx != 0" style="cursor: pointer;" @click="forup(scope.row)">
										<div style="margin-right: 5px;">上移</div>
										<img src="../../../assets/img/moveup.png" width="13px" height="16px" />
									</div>
									<div class="Centerupdown" v-if="scope.row.shunx != parseInt(totalcount) - 1" style="cursor: pointer;" @click="fordown(scope.row)">
										<div style="margin-right: 5px;">下移</div>
										<img src="../../../assets/img/movedown.png" width="13px" height="16px" />
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100" align="center">
							<template slot-scope="scope" v-if="scope.row.ruleType == '0'"></template>
							<template slot-scope="scope">
								<el-button v-if="scope.row.ruleType == '1'" type="text" size="small" @click="forupdate(scope.row)">编辑</el-button>
								<el-button v-if="scope.row.ruleType == '0'" type="text" size="small" @click="viewRow(2)">查看</el-button>
								<el-button v-if="scope.row.ruleType == '1'" type="text" size="small" @click="forDelete(scope.row)" style="color: red;">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="buttompage">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[10, 20, 100, 500]"
						:page-size="pagenum"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalcount"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseRule from '@/components/page/Controloverinvoices/BaseRules';
export default {
	components: { BaseRule },
	data() {
		return {
			chooseform: '',
			diaglist: [{}],
			radio: 0,
			/* 开具弹框 */
			xjdialog: false,
			guizlxbh: '1',
			xjtitle: '拆分金额',
			options: [
				{
					value: '1',
					label: '拆分金额'
				},

				{
					value: '2',
					label: '拆分最大明细行'
				},
				{
					value: '3',
					label: '合并发票'
				},
				{
					value: '4',
					label: '合并明细'
				},
				{
					value: '5',
					label: '替换名称'
				},
				{
					value: '9',
					label: '修改单据状态'
				},
				{
					value: '10',
					label: '修改备注'
				}
			],
			/* 作用范围下拉 */
			yxfwoptions: [
				{
					value: '0',
					label: '作用全部'
				},
				{
					value: '1',
					label: '作用当前'
				},
				{
					value: '2',
					label: '排除当前'
				}
			],
			fplxoptions: [{ label: '纸质专票', value: '004' }, { label: '纸质普票', value: '007' }, { label: '电子专票', value: '028' }, { label: '电子普票', value: '026' }],
			kehfw: '0',
			/* 客户代码和名称下拉 */
			kehuoptions: [],
			goufbh: '',
			/* 筛选条件下拉 */
			shaixuanoptions: [],
			shaixtj: [{}],
			// 筛选条件操作符下拉
			caozfoptions: [
				{
					value: '1',
					label: '等于'
				},
				{
					value: '2',
					label: '大于'
				},
				{
					value: '3',
					label: '小于'
				},
				{
					value: '4',
					label: 'like'
				},
				{
					value: '5',
					label: '不等于'
				}
			],
			subform: {
				// 拆分金额
				zuidcfje: '', // 最大拆分金额
				chaifsl: '',
				chaifdj: '',
				chaifzdhs: '', //拆分最大行数
				//发票分组

				fenzbz: '',
				fenzbzz: '',
				fenzzdje: '',
				fenzulist: [{}],
				hblist: [{}],
				bzlist: [{}],
				hebsl: '',
				hebslz: '',
				hebdj: '',
				hebdjz: '',
				hebspm: '',
				hebspmz: '',
				hebgg: '',
				hebggz: '',
				hebdw: '',
				hebdwz: '',
				hebbz: '',
				hebbzz: '',
				tihmc: '',
				tihz: '',
				danjzt: ''
			},
			//拆分最大明细行
			chaifennumoptions: [
				{
					value: '0',
					label: '不变'
				},
				{
					value: '1',
					label: '反算'
				}
			],

			fenzuoptions: [],
			bzoptions: [
				{
					value: '1',
					label: '首行'
				},
				{
					value: '2',
					label: '固定值'
				},
				{
					value: '3',
					label: '拼接'
				}
			],

			// 合并明细
			hbnumberoptions: [
				{
					value: '1',
					label: '相加'
				},
				{
					value: '2',
					label: '反算'
				},
				{
					value: '3',
					label: '固定值'
				}
			],
			hbpriceoptions: [
				{
					value: '1',
					label: '反算'
				},
				{
					value: '2',
					label: '固定值'
				}
			],
			hbshopoptions: [
				{
					value: '1',
					label: '首行'
				},
				{
					value: '2',
					label: '固定值'
				}
			],
			hbguigeoptions: [
				{
					value: '1',
					label: '首行'
				},
				{
					value: '2',
					label: '固定值'
				}
			],
			hbdanweioptions: [
				{
					value: '1',
					label: '首行'
				},
				{
					value: '2',
					label: '固定值'
				}
			],
			hbbzoptions: [
				{
					value: '1',
					label: '首行'
				},
				{
					value: '2',
					label: '固定值'
				},
				{
					value: '3',
					label: '拼接'
				}
			],

			//替换名称

			tihoptions: [
				{
					value: '1',
					label: '商品'
				},
				{
					value: '2',
					label: '客户'
				},
				{
					value: '3',
					label: '单位'
				},
				{
					value: '4',
					label: '规格'
				}
			],

			//修改单据状态
			danjuoptions: [
				{ key: '0', value: '待审核' },
				{ key: '1', value: '已审核' },
				{ key: '2', value: '待开票' },
				{ key: '3', value: '开票中' },
				{ key: '4', value: '已开票' },
				{ key: '5', value: '已作废' },
				{ key: '6', value: '已红冲' },
				{ key: '7', value: '开票失败' },
				{ key: '8', value: '暂不开票' },
				{ key: '9', value: '已退票' },
				{ key: '21', value: '待作废' }
			],
			//备注状态
			bzwzoptions: [
				{
					value: '1',
					label: '前'
				},
				{
					value: '2',
					label: '后'
				}
			],
			page: 1,
			pagenum: 10,
			totalcount: 10,
			tableData: [],
			headtitle: ['发票管理', '开票规则'],
			serchval: '',
			tableHeight: '',
			fplxs: [],
			fpfw: '0',
			baseRuleDoalog: false,
			baseRuleData: [],
			viewFlag: false,

			splitMaxAmount: ''
		};
	},
	created() {
		this.getRuleList();
	},
	mounted() {
		this.$nextTick(() => {
			this.tableHeight = this.diagheight();
			this.$refs.multipleTable.doLayout();
			window.onresize = () => {
				this.tableHeight = this.diagheight();
				this.$refs.multipleTable.doLayout();
			};
		});
	},
	methods: {
		fpfwChange(value) {
			if (value == 0) {
				this.fplxs = [];
			}
		},
		fplxChange(value) {
			let filterData = this.baseRuleData.filter(item => item.fplxs == value);
			if (filterData.length > 0) {
				this.splitMaxAmount = filterData[0].hansje;
			} else {
				this.splitMaxAmount = '';
			}
		},
		kehfwChange(value) {
			if (value == 0) {
				this.goufbh = [];
			}
		},
		/**
		 * 保存基础规则
		 */
		saveBaseRuleData(data) {
			let params = JSON.stringify(data);
			this.$https.fetchPost('rule/saveBaseRules', params).then(res => {
				if (res.data.success) {
					this.$message.success('新增成功');
					this.baseRuleDoalog = false;
					this.getRuleList();
				}
			});
		},
		closeDialog() {
			this.baseRuleDoalog = false;
		},
		viewRow(type) {
			this.$https.fetchPost('rule/findBaseRules').then(res => {
				console.log(res);
				if (res.data.success) {
					if (type == 2) {
						this.viewFlag = true;
					} else {
						this.viewFlag = false;
					}
					this.baseRuleData = res.data.obj;
					this.baseRuleDoalog = true;
				}
			});
		},
		forDelete(row) {
			let params = row.ruleId;
			this.$https.fetchPost('rule/deleteRule', params).then(res => {
				if (res.data.success) {
					this.$message.info('删除成功');
					this.getRuleList();
				}
			});
		},
		forupdate(row) {
			this.release();
			if (this.guizlxbh == '4' || this.guizlxbh == '3') {
				this.getRuleConditionFieldszu();
			}
			this.getRuleConditionFields();
			this.getCustomer();
			this.getRule(row.ruleId);
		},
		fordown(row) {
			let json = {
				qiybh: row.qiybh,
				index: row.shunx,
				type: 'down'
			};
			this.swapRule(JSON.stringify(json));
		},
		forup(row) {
			let json = {
				qiybh: row.qiybh,
				index: row.shunx,
				type: 'up'
			};
			this.swapRule(JSON.stringify(json));
		},
		kehfwtostring(value) {
			let valueformat;
			switch (value) {
				case '0':
					valueformat = '全部客户';
					break;
				case '1':
					valueformat = '指定客户';
					break;
				case '2':
					valueformat = '排除客户';
					break;
			}
			return valueformat;
		},
		ruleTypetostring(value) {
			let valueformat;
			switch (value) {
				case '0':
					valueformat = '基础规则';
					break;
				case '1':
					valueformat = '高级规则';
					break;
			}
			return valueformat;
		},
		fplxtostring(value) {
			let valueformat = [];
			if (value != '' && value != null) {
				let fplxsArray = value.split(',');
				for (let i = 0; i < fplxsArray.length; i++) {
					if (fplxsArray[i] == '004') {
						valueformat.push('纸质专票');
					} else if (fplxsArray[i] == '007') {
						valueformat.push('纸质普票');
					} else if (fplxsArray[i] == '026') {
						valueformat.push('电子普票');
					} else if (fplxsArray[i] == '028') {
						valueformat.push('电子专票');
					}
				}
			}

			return valueformat.join(',');
		},
		release() {
			this.kehfw = '0';
			this.goufbh = '';
			this.shaixtj = [{}];
			Object.keys(this.subform).map(key => (this.subform[key] = ''));
			(this.subform.fenzulist = [{}]), (this.subform.hblist = [{}]), (this.subform.bzlist = [{}]);
		},
		forsaveRule() {
			console.log(this.subform);
			if (this.subform.guizlxbh == '1') {
				let fplx = this.subform.fplxs;
				if (fplx == null || fplx == '') {
					this.$message.error('请选择发票类型！');
					return false;
				}
				let filterData = this.baseRuleData.filter(item => item.fplxs == fplx);
				if (filterData.length == 0) {
					this.$message.error('请先维护该发票基础规则！');
					return false;
				}
			}
			if ((this.kehfw != '0') & (this.goufbh == '')) {
				this.$message.error('客户信息不能为空');
				return false;
			}
			let shaixuanstate = false;
			this.shaixtj.forEach(item => {
				if (this.emptyandnull(item.zidm) || this.emptyandnull(item.caozf) || this.emptyandnull(item.zhi)) {
					shaixuanstate = true;
				}
				if (item.zidm == 'hansbz') {
					let value = item.value;
					if (item.value != '是' && item.value != '否') {
						this.$message.error('筛选条件-含税标志只能填写 是 或 否');
						return false;
					} else {
						item.value = value == '是' ? 1 : 0;
					}
				}
				if (item.zidm == 'hasList') {
					let value = item.value;
					if (item.value != '是' && item.value != '否') {
						this.$message.error('筛选条件-是否有清单只能填写 是 或 否');
						return false;
					} else {
						item.value = value == '是' ? 1 : 0;
					}
				}
			});
			if ((this.guizlxbh != '4') & shaixuanstate) {
				this.$message.error('筛选条件不能为空');
				return false;
			}
			if (this.guizlxbh == '1') {
				// if(this.emptyandnull(this.subform.zuidcfje) ){
				// 	this.$message.error('最大拆分金额不能为空');
				// 	return false
				// }
			}
			if (this.guizlxbh == '2') {
				if (this.emptyandnull(this.subform.chaifsl)) {
					this.$message.error('数量不能为空');
					return false;
				}
				if (this.emptyandnull(this.subform.chaifdj)) {
					this.$message.error('单价不能为空');
					return false;
				}
				if (this.emptyandnull(this.subform.chaifzdhs)) {
					this.$message.error('最大行数不能为空');
					return false;
				}
			}
			if (this.guizlxbh == '3') {
				let fenzustate = false;
				this.subform.fenzulist.forEach(item => {
					if (this.emptyandnull(item.hebzdm)) {
						fenzustate = true;
					}
				});
				if (this.emptyandnull(this.subform.fenzbz)) {
					this.$message.error('备注不能为空');
					return false;
				}
				if (this.emptyandnull(this.subform.fenzzdje)) {
					this.$message.error('最大金额不能为空');
					return false;
				}
				if (fenzustate) {
					this.$message.error('分组条件不能空');
					return false;
				}
				if ((this.subform.fenzbz == '2') & (this.subform.fenzbzz == '')) {
					this.$message.error('固定值不能空');
					return false;
				}
			}
			if (this.guizlxbh == '4') {
				let hebingstate = false;
				this.subform.hblist.forEach(item => {
					if (this.emptyandnull(item.zidm)) {
						hebingstate = true;
					}
				});
				if (hebingstate) {
					this.$message.error('合并条件不能空');
					return false;
				}
				if (this.emptyandnull(this.subform.hebsl)) {
					this.$message.error('数量不能为空');
					return false;
				}
				if (
					(this.subform.hebsl == '3') & (this.subform.hebslz == '') ||
					(this.subform.hebdj == '2') & (this.subform.hebdjz == '') ||
					(this.subform.hebgg == '2') & (this.subform.hebggz == '') ||
					(this.subform.hebdw == '2') & (this.subform.hebdwz == '') ||
					(this.subform.hebspm == '2') & (this.subform.hebspmz == '') ||
					(this.subform.hebbz == '2') & (this.subform.hebbzz == '')
				) {
					this.$message.error('固定值不能为空');
					return false;
				}
				if (this.emptyandnull(this.subform.hebdj)) {
					this.$message.error('单价不能为空');
					return false;
				}

				if (this.emptyandnull(this.subform.hebspm)) {
					this.$message.error('商品名不能为空');
					return false;
				}
				if (this.emptyandnull(this.subform.hebgg)) {
					this.$message.error('规格不能为空');
					return false;
				}
				if (this.emptyandnull(this.subform.hebdw)) {
					this.$message.error('单位不能为空');
					return false;
				}
				if (this.emptyandnull(this.subform.hebbz)) {
					this.$message.error('明细备注不能为空');
					return false;
				}
			}
			if (this.guizlxbh == '5') {
				if (this.emptyandnull(this.subform.tihmc)) {
					this.$message.error('替换名称不能为空');
					return false;
				}
				if (this.emptyandnull(this.subform.tihz)) {
					this.$message.error('替换值不能为空');
					return false;
				}
			}
			if (this.guizlxbh == '8') {
				if (this.emptyandnull(this.subform.danjzt)) {
					this.$message.error('单据不能为空');
					return false;
				}
			}
			if (this.guizlxbh == '10') {
				let bzstate = false;
				let xglx1 = false;
				let xglx2 = false;
				this.subform.bzlist.forEach(item => {
					if (this.emptyandnull(item.beizxglx)) {
						bzstate = true;
					}
					if (item.beizxglx == '1' && (this.emptyandnull(item.beizxgwz) || this.emptyandnull(item.beizxgzd) || this.emptyandnull(item.beizxgws))) {
						xglx1 = true;
					}
					if (item.beizxglx == '2' && this.emptyandnull(item.beizxgzzbds)) {
						xglx2 = true;
					}
				});
				if (bzstate) {
					this.$message.error('备注处理不能为空');
					return false;
				}
				if (xglx1) {
					this.$message.error('备注处理字段修改配置不能为空');
					return false;
				}
				if (xglx2) {
					this.$message.error('备注处理正则表达式值不能为空');
					return false;
				}
			}

			let params = this.subform;

			params.guizlxbh = this.guizlxbh;
			params.kehfw = this.kehfw;
			params.goufbh = this.goufbh;
			params.shaixtj = this.shaixtj;
			if (this.fpfw != '0' && this.fplxs.length == 0) {
				this.$message.error('请选择发票类型');
			}
			params.fplxs = this.fplxs.toString();
			params.fpfw = this.fpfw;
			if (this.guizlxbh == '5') {
				params.guizlxbh = (parseInt(this.subform.tihmc) + 4).toString();
			}
			if (this.notemptyandnull(this.subform.ruleId)) {
				params.ruleId = this.subform.ruleId;
				this.$https.fetchPost('rule/updateRule', params).then(res => {
					if (res.data.success) {
						this.$message.success('编辑成功');
						this.xjdialog = false;
						this.getRuleList();
					}
				});
			} else {
				this.$https.fetchPost('rule/saveRule', params).then(res => {
					if (res.data.success) {
						this.$message.success('新增成功');
						this.xjdialog = false;
						this.getRuleList();
					}
				});
			}
		},
		/* 筛选条件下拉 */
		addshaixtj() {
			this.shaixtj.push({});
		},
		delteshaixtj(index) {
			if (this.shaixtj.length < 2) {
				return false;
			}
			this.shaixtj.splice(index, 1);
		},
		// 分组条件下拉
		addfenzulist() {
			this.subform.fenzulist.push({});
		},
		deltefenzulist(index) {
			if (this.subform.fenzulist.length < 2) {
				return false;
			}
			this.subform.fenzulist.splice(index, 1);
		},
		//合并条件下拉
		addhblist() {
			this.subform.hblist.push({});
		},
		deltehblist(index) {
			if (this.subform.hblist.length < 2) {
				return false;
			}
			this.subform.hblist.splice(index, 1);
		},
		// 备注条件下拉
		addbzlist() {
			this.subform.bzlist.push({});
		},
		deltebzlist(index) {
			if (this.subform.bzlist.length < 2) {
				return false;
			}
			this.subform.bzlist.splice(index, 1);
		},
		changeselect(e) {
			this.options.forEach(item => {
				if (item.value == this.guizlxbh) {
					this.xjtitle = item.label;
				}
			});
		},
		foradddiag(value) {
			this.$https.fetchPost('rule/findBaseRules').then(res => {
				console.log(res);
				if (res.data.success) {
					if (res.data.obj.length > 0) {
						this.baseRuleData = res.data.obj;
					}
					// else {
					//     this.$message.warning("请先配置基础规则")
					//     this.baseRuleDoalog=true;
					//     return;
					// }
				}
			});
			this.guizlxbh = value;
			this.changeselect();
			this.release();
			if (this.guizlxbh == '4' || this.guizlxbh == '3') {
				this.getRuleConditionFieldszu();
			}
			if (this.guizlxbh == '1') {
				this.fpfw = '1';
			}
			this.getRuleConditionFields();
			this.getCustomer();
			this.xjdialog = true;
		},
		handleSizeChange(val) {
			this.pagenum = val;
			this.getRuleList();
		},
		changebilling() {
			this.getRuleList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getRuleList();
		},
		// 接口调用操作
		// 获取客户代码,客户名称
		getCustomer() {
			let params = {};
			this.$https.fetchPost('rule/getCustomer', params).then(res => {
				this.kehuoptions = res.data.obj;
			});
		},
		getRuleConditionFields() {
			let fieldType = '0';

			let params = fieldType;
			this.$https.fetchPost('rule/getRuleConditionFields', params).then(res => {
				this.shaixuanoptions = res.data.obj;
			});
		},
		getRuleConditionFieldszu() {
			let fieldType = '1';

			let params = fieldType;
			this.$https.fetchPost('rule/getRuleConditionFields', params).then(res => {
				this.fenzuoptions = res.data.obj;
			});
		},
		getRuleList() {
			let params = {
				likeSearch: this.serchval,
				page: this.page,
				limit: this.pagenum
			};
			this.$https.fetchPost('/rule/getRuleList', params).then(res => {
				this.totalcount = res.data.count;
				this.tableData = res.data.data;
			});
		},
		swapRule(e) {
			let params = e;
			this.$https.fetchPost('rule/swapRule', params).then(res => {
				console.log(res);
				if (res.data.success) {
					this.getRuleList();
				}
			});
		},
		getRule(e) {
			let params = e;
			this.$https.fetchPost('rule/getRule', params).then(res => {
				this.subform = res.data.obj;
				console.log(this.subform);
				this.guizlxbh = this.subform.guizlxbh;
				this.kehfw = this.subform.kehfw;
				this.goufbh = this.subform.goufbh;
				this.shaixtj = this.subform.shaixtj;
				this.xjtitle = this.formatkpgz(this.guizlxbh);
				if (this.guizlxbh == '6' || this.guizlxbh == '7' || this.guizlxbh == '8') {
					this.guizlxbh = '5';
				}
				this.xjdialog = true;
			});
		}
	}
};
</script>

<style scoped="scoped" lang="less">
.bzchli/deep/.el-radio {
	margin-right: 0px;
}
.bzchli/deep/.el-radio__label {
	display: none;
}
.Centerupdown > span {
	width: 70px;
}

.blueicon:extend(.Centerhorizontally) {
	width: 66px;
	height: 25px;
	border: 1px solid #0080ff;
	opacity: 1;
	border-radius: 2px;
	font-size: 12px;
	font-weight: 400;
	color: #0080ff;
	margin-left: 23px;
	cursor: pointer;
}
.redicon:extend(.Centerhorizontally) {
	width: 66px;
	height: 25px;
	border: 1px solid #e80057;
	opacity: 1;
	border-radius: 2px;
	font-size: 12px;
	font-weight: 400;
	margin-left: 23px;
	color: #e80057;
	cursor: pointer;
}
.diagtitle {
	font-size: 15px;
	font-weight: 400;
	color: #0080ff;
	margin-top: 28px;
	margin-left: 22px;
}

.diagtitle:nth-of-type(1) {
	margin-top: 0px;
}
.otherchoose /deep/.el-input__inner {
	color: #0080ff;
	border: 1px solid #0080ff;
}
.otherchoose/deep/.el-icon-arrow-up:before {
	color: #0080ff;
}
// /deep/.el-dialog__body {
// 	padding: 0;
// }
/deep/.el-table--small td {
	padding: 4px 0;
}
/deep/.el-table__body-wrapper {
	min-height: 160px;
}

.areatable {
	margin-top: 27px;
}
.areacontent {
	margin-left: 21px;
}
</style>
